import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { SiteLayout } from "@/components/Footer";

import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import Housing from "@/pages/Housing";
import FinancialWellness from "@/pages/FinancialWellness";
import Grants from "@/pages/Grants";
import Donate from "@/pages/Donate";
import Volunteer from "@/pages/Volunteer";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import Apply from "@/pages/Apply";
import Sponsor from "@/pages/Sponsor";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/marketplace" element={<SiteLayout><Marketplace /></SiteLayout>} />
            <Route path="/housing" element={<SiteLayout><Housing /></SiteLayout>} />
            <Route path="/financial-wellness" element={<SiteLayout><FinancialWellness /></SiteLayout>} />
            <Route path="/grants" element={<SiteLayout><Grants /></SiteLayout>} />
            <Route path="/donate" element={<SiteLayout><Donate /></SiteLayout>} />
            <Route path="/volunteer" element={<SiteLayout><Volunteer /></SiteLayout>} />
            <Route path="/events" element={<SiteLayout><Events /></SiteLayout>} />
            <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
            <Route path="/founder" element={<SiteLayout><Founder /></SiteLayout>} />
            <Route path="/apply" element={<SiteLayout><Apply /></SiteLayout>} />
            <Route path="/sponsor" element={<SiteLayout><Sponsor /></SiteLayout>} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
